<!-- =========================================================================================
  File Name: UserCreate.vue
  Description: User Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <view-page
    :baseRoute='baseRoute'
    :entity='entity'
    :button-access="componentAccess"
    :model-entity="modelEntity"
    :skip-auto-fetch="true"
    :external-model="model"
  >
    <template v-slot="{ model }">
      <vs-alert color="warning" title="Deleted Record" v-if="model.IsDeleted" class="mb-4">
        <span>You are viewing the record for a deleted contact</span>
      </vs-alert>
      <user-profile-form
        ref="profile"
        readonly
        v-model="model"
      />
      <user-details-form
        ref="userDetailsForm"
        readonly
        v-model="model"
      />
    </template>

    <template v-slot:extra-button="{ model }">
      <vs-button
          v-if="componentAccess.canPublish.access && model"
          class="mt-2 ml-4"
          color="light"
          @click="openEnableAlert(model)"
      >
        {{ model.IsEnabled ? "Deactivate" : "Activate" }}
      </vs-button>
    </template>
  </view-page>
</template>

<script>
import UserProfileForm from '../forms/UserProfileForm';
import UserValidation from '@/validation/User';
import UserDetailsForm from '../forms/UserDetailsForm';
UserValidation.init();

// Store Module
import NotificationMixin from '../../../../components/mixins/NotificationMixin';
import ViewPage from '../../../components/Views/ViewPage';
import EnablePublishMixin from '../../../../components/mixins/EnablePublishMixin';

export default {
  components: {
    UserProfileForm,
    UserDetailsForm,
    ViewPage
  },
  mixins: [NotificationMixin, EnablePublishMixin],
  data() {
    return {
      baseRoute: "contact",
      entity: "Contact",
      internalLoading: false,
      user_not_found: false,
      user_data: null,
      model: {}, // Required for EnablePublishMixin
      forms: ['profile', 'userDetailsForm'],
      modelEntity: this.$api.users,
      componentAccess: {
        canEdit: {
          route: 'contact.edit',
          access: false
        },
        canDelete: {
          route: 'contact.delete',
          access: false
        },
        canRestore: {
          route: 'contact.restore',
          access: false
        },
        canPublish: {
          route: 'contact.publish',
          access: false,
        },
      }
    };
  },
  computed: {
    isInternalUser() {
      return this.user_data && this.user_data.IsInternalUser === true;
    },
    internalUserNotActive() {
      return this.isInternalUser && !this.user_data.ExternalIdentity_Key;
    }
  },
  methods: {
    setPageTitle() {
      if (!this.user_data) {
        return '';
      }

      return `${this.user_data.Title ? this.user_data.Title : ''} ${
        this.user_data.FirstName ? this.user_data.FirstName : ''
      } ${this.user_data.MiddleName ? this.user_data.MiddleName : ''} ${
        this.user_data.LastName ? this.user_data.LastName : ''
      }`;
    },
    async validateSave() {
      let valid = true;

      this.forms.forEach(form => {
        if (!this.$refs[form].validate()) {
          valid = false;
        }
      });

      return valid;
    },
    cancel() {
      this.$root.$router.push({ path: `/contacts/${this.user_data.id}` });
    },
    async fetch(userId) {
      try {
        const { data } = await this.$api.users.get(userId);
        this.user_data = data.data;
        this.model = data.data; // Set model for EnablePublishMixin (and ViewPage via externalModel prop)
        await this.$store.dispatch('updateIsDeleted', data.data.IsDeleted);
        await this.$store.dispatch('updatePageTitle', this.setPageTitle());
      } catch (e) {
        console.error(e);
      } finally {
        if (!this.user_data) {
          this.user_not_found = true;
        }
      }
    }
  },
  async mounted() {
    await this.fetch(this.$route.params.id);
  },
};
</script>
